module.exports = __webpack_public_path__ + "static/media/cq_nascondi b.ed420346.svg";